var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1 9.9a3 3 0 010 4.2 3 3 0 01-4.2 0 3 3 0 010-4.2 3 3 0 014.2 0",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M16.2 18.7v0c.5.5 1.3.5 1.8 0l.7-.7c.5-.5.5-1.4 0-1.9v0c-.4-.3-.5-.9-.3-1.4l.1-.2c.2-.4.6-.7 1.1-.7h.1c.7 0 1.3-.6 1.3-1.3v-1c0-.7-.6-1.3-1.3-1.3h0c-.6 0-1-.3-1.2-.8v-.1c-.3-.5-.2-1 .2-1.5v0c.5-.5.5-1.3 0-1.8l-.7-.7c-.5-.5-1.3-.5-1.8 0v0c-.4.4-1 .5-1.5.3h-.1c-.5-.3-.8-.7-.8-1.2v0c0-.8-.6-1.4-1.3-1.4h-1c-.7 0-1.3.6-1.3 1.3v0c0 .6-.3 1-.8 1.2h-.1c-.5.3-1.1.2-1.5-.2v0c-.5-.5-1.3-.5-1.8 0l-.7.7c-.5.5-.5 1.3 0 1.8v0c.4.4.5 1 .3 1.5l-.1.1c-.2.5-.6.8-1.1.8h-.1c-.7 0-1.3.6-1.3 1.3v1c0 .7.6 1.3 1.3 1.3h0c.6 0 1 .3 1.2.7v.2c.3.5.2 1-.2 1.4v0c-.5.5-.5 1.4 0 1.9l.7.7c.5.5 1.3.5 1.8 0v0c.4-.4 1-.5 1.5-.3h.1c.5.2.8.7.8 1.2v0c0 .8.6 1.3 1.3 1.3h1c.7 0 1.3-.5 1.3-1.2v-.1c0-.5.3-1 .8-1.1l.1-.1c.5-.2 1.1-.1 1.5.3v0z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgSettings;